import { render, staticRenderFns } from "./BreakEditTab.vue?vue&type=template&id=68ad10cf&scoped=true"
import script from "./BreakEditTab.vue?vue&type=script&lang=js"
export * from "./BreakEditTab.vue?vue&type=script&lang=js"
import style0 from "./BreakEditTab.vue?vue&type=style&index=0&id=68ad10cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad10cf",
  null
  
)

export default component.exports